// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4d-5";
export var imageContainer = "_4d-4";
export var metricsGrid = "_4d-2";
export var productDetailContainer = "_4d-1";
export var productListContainer = "_4d-0";
export var subscriberTableContainer = "_4d-3";